import { REQUIRED_COOKIES_MAP } from '../consts';

export const getDiscountPercentage = (
  basePrice: number,
  salePrice: number
): string => `${(100 - (salePrice * 100) / basePrice).toFixed()}%`;

export const setSpaceBetweenDigits = (digits: number): string =>
  digits.toString().replace(/\B(?=(?:\d{3})*$)/g, ' ');

export const getCookies = () => {
  let matches = document.cookie.split(';').map((item) => item.split('=')[0].trim());
  return matches;
};

export const applyCookies = (cookies: string[]) => {
  Object.entries(REQUIRED_COOKIES_MAP).forEach(([key, value]) => {
    if (!cookies.includes(key)) {
      document.cookie = `${key}=${value};path=/;domain=.mvideo.ru`;
    }
  })
};